import { z } from 'zod';

import { DiagramPositionSchema } from './DiagramPosition.schema';

export const TEXT_AREA_FONT_SIZES = [
    {
        label: 'Small',
        value: '13px',
    },
    {
        label: 'Medium',
        value: '16px',
    },
    {
        label: 'Large',
        value: '20px',
    },
    {
        label: 'Extra Large',
        value: '24px',
    },
    {
        label: 'Huge',
        value: '32px',
    },
];

export const DiagramTextareaSchema = z.object({
    id: z.string(),
    position: DiagramPositionSchema,
    dimensions: z.object({
        width: z.number(),
        height: z.number(),
    }),
    color: z.string().default('#000000'),
    fontSize: z.string().default(TEXT_AREA_FONT_SIZES[0].value),
    borderStyle: z.string().default(''),
    borderColor: z.string().default(''),
    backgroundColor: z.string().default(''),
    content: z.object({}).passthrough(),
});
